var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      {
        staticClass: "profile__header",
        attrs: { id: "profile__header--section" }
      },
      [
        _vm.profile.avatar
          ? _c("img", {
              staticClass: "avatar rounded",
              attrs: { src: _vm.profile.avatar }
            })
          : _vm._e(),
        _c("h1", { staticClass: "header section-header" }, [
          _vm._v(_vm._s(_vm.profile.realname))
        ]),
        _c("p", [_vm._v(_vm._s(_vm.profile.description))]),
        _c("a", { attrs: { href: _vm.profile.url } }, [
          _c("p", [_vm._v(_vm._s(_vm.profile.url))])
        ])
      ]
    ),
    _c(
      "section",
      {
        directives: [
          {
            name: "scroll",
            rawName: "v-scroll",
            value: _vm.handleScroll,
            expression: "handleScroll"
          }
        ],
        staticClass: "profile__grid--menu"
      },
      [
        _c("div", { attrs: { id: "profile__header--container" } }, [
          _c("div", { staticClass: "profile__grid--header" }, [
            _c("div", { staticClass: "toggle" }, [
              _c(
                "div",
                {
                  staticClass: "bars",
                  class: { active: !_vm.gridView },
                  on: {
                    click: function($event) {
                      _vm.gridView = false
                    }
                  }
                },
                [
                  _c("div", { staticClass: "bar" }),
                  _c("div", { staticClass: "bar" })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "grid",
                  class: { active: _vm.gridView },
                  on: {
                    click: function($event) {
                      _vm.gridView = true
                    }
                  }
                },
                [
                  _c("div", { staticClass: "square" }),
                  _c("div", { staticClass: "square" }),
                  _c("div", { staticClass: "square" }),
                  _c("div", { staticClass: "square" })
                ]
              )
            ]),
            _c("div", { staticClass: "profile__grid--info" }, [
              _vm.profile.avatar
                ? _c("img", {
                    staticClass: "avatar rounded",
                    attrs: { src: _vm.profile.avatar }
                  })
                : _vm._e(),
              _c("h1", { staticClass: "header section-header" }, [
                _vm._v(_vm._s(_vm.profile.realname))
              ])
            ])
          ])
        ])
      ]
    ),
    _c("section", [
      _c(
        "div",
        { staticClass: "flixel__grid" },
        [
          _c("flixel-list", {
            attrs: {
              flixels: _vm.flixels,
              "grid-view": _vm.gridView,
              profilePage: "true"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ced23842", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ced23842","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
// module id = null
// module chunks = 